import { HttpClient, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, finalize, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Intervention } from '../domain/planning/intervention';
import { CoreData } from '../tools/core-data';
import { LoadingTask } from '../tools/loading-task';
import { EDocumentType } from '../tools/ui/mutilple-file-upload-box/document-type';
import { BaseService } from './base-service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Carte } from '../models/carte';

@Injectable({
    providedIn: 'root',
})
export class DocumentService extends BaseService {

    private serviceUrl = `${environment.serviceMainBaseUrl}api/document`;

    constructor(protected http: HttpClient,
        protected coreData: CoreData,
        protected snackBare: MatSnackBar,
        protected loadingTask: LoadingTask,
        protected router: Router,
    ) {
        super(coreData, router, snackBare);
    }

    getDocumentByIntervention(interventionCode: string, documentCode: string) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/${interventionCode}/${documentCode}`, this.generateHeaderForFileDownload()).pipe(
            catchError(this.handleError<any>('getDocumentByIntervention')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map(x => x));
    }

    getDocument(documentCode: string) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/${documentCode}`, this.generateHeaderForFileDownload()).pipe(
            catchError(this.handleError<any>('getDocumentByIntervention')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map(x => x));
    }

    // getDocument(edmCode: string) {
    //     window.open(`${this.serviceUrl}/${edmCode}`, '_blank');
    // }

    getAllDocumentByFilter(searchText: string) {

        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/ByFilter/${searchText}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getDocuments')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: Intervention) => {
                return Intervention.mapFromJSON(response);
            }));
    }

    /**
     * 
     * @param Code InterventionCode / Analysis Code / IBMR Taxon Code / NumLot 
     * @param documentType 
     * @param file 
     * @returns 
     */
    createDocument(Code: string, documentType: EDocumentType, file: File) {
        const formData: FormData = new FormData();

        formData.append('file', file, file.name);
        formData.append('documentType', `${documentType}`);

        return this.http.request(new HttpRequest('POST', `${this.serviceUrl}/${Code}`, formData, this.generateHeaderForFormData()))
            .pipe(
                catchError(this.handleError<any>('createDocument')),
                map((x => x)));
    }

    createInterventionList(documentType: EDocumentType, file: File) {
        const formData: FormData = new FormData();

        formData.append('file', file, file.name);
        formData.append('documentType', `${documentType}`);

        return this.http.request(new HttpRequest('POST', `${this.serviceUrl}`, formData, this.generateHeaderForFormData()))
            .pipe(
                catchError(this.handleError<any>('createIntervention')));
    }

    deleteDocument(interventionCode: string, documentCode: string) {
        this.loadingTask.activateLoading();

        return this.http.delete(`${this.serviceUrl}/${interventionCode}/${documentCode}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('deleteDocument')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((x: number) => x));
    }

    deleteTaxonDocument(documentCode: string) {
        this.loadingTask.activateLoading();

        return this.http.delete(`${this.serviceUrl}/${documentCode}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('deleteTaxonDocument')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((x: number) => x));
    }

    uploadPhoteDesJolisTaxon(analyseCode: string, files: File[]) {
        const formData: FormData = new FormData();

        this.loadingTask.activateLoading();
        files.forEach(file => {
            formData.append('files', file, file.name);
        });

        return this.http.request(new HttpRequest('POST', this.serviceUrl + `/${analyseCode}/ibmrPictures`, formData, this.generateHeaderForFormData()))
            .pipe(
                catchError(this.handleError<any>('uploadPhoteDesJolisTaxon')),
                finalize(() => this.loadingTask.deactivateLoading()))

    }


    getLast30Lot() {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/carte/last30`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getLast30carte')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: Carte[]) => {
                return response.map((item: Carte) => {
                    return Carte.mapFromJSON(item);
                });
            })
        );
    }

    getLotByFilter(filter: string) {
        this.loadingTask.activateLoading();
        let params = new HttpParams();
        if (filter) {
            params = params.append('filter', `${filter}`);
        }
        return this.http.get(`${this.serviceUrl}/carte/byFilter/`, this.generateHeaderWithParameters(params)).pipe(
            catchError(this.handleError<any>('getcarteByFilter')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: Carte[]) => {
                return response.map((item: Carte) => {
                    return Carte.mapFromJSON(item);
                });
            })
        );
    }

    deleteLot(numeroLot: string) {
        this.loadingTask.activateLoading();

        return this.http.delete(`${this.serviceUrl}/carte/${numeroLot}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('deletecarte')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map(x => x));
    }
}
